// extracted by mini-css-extract-plugin
export default {"container":"DI-z","error":"EI-z","disabled":"FI-z","submit":"GI-z","option":"HI-z","success":"II-z","failure":"JI-z"};